import { Wording } from '@/types';

export const ASTROLOGY_WORDING_SK: Wording = {
  components_header_media_content: 'Zvuky',
  components_header_media_1: 'Meditácie',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Sprievodcovia',
  components_header_text2: 'Blog',
  components_header_members: 'členov',
  hero_text: 'Preskúmajte hviezdy vo vnútri',
  hero_button_text: 'Začnite tu',
  components_ressources_section_title: 'ZDROJE',
  components_ressources_subheader_text: 'Všetky nástroje, ktoré potrebujete pre kozmický pohľad a sebaobjavovanie',
  components_ressources_span_text: 'Rozšírte svoj vnútorný vesmír pomocou vybranej zmesi podcastov a článkov. Či už hľadáte kozmický pohľad, jasnosť alebo duchovné vyrovnanie, naše zdroje vám pomôžu spojiť sa s astrológiou praktickými a zmysluplnými spôsobmi.',
  components_ressources_card_1_title: 'Hlboké ponory',
  components_ressources_card_1_text: 'Ponorte sa do bohatej zbierky podrobných podcastov pokrývajúcich astrológiu, tarot, kozmické archetypy a duchovný rast – navrhnutých na rozšírenie vášho povedomia a prehĺbenie vašej praxe.',
  components_ressources_card_2_title: 'Hviezdne štatistiky',
  components_ressources_card_2_text: 'Astrologické tipy a blogové príspevky pre sebauvedomenie a oduševnený rast.',
  components_ressources_link: 'Preskúmať ďalej',
  components_notes_and_google_title_1: 'Astrologické usmernenie',
  components_notes_and_google_title_2: 'Kozmická rutina',
  components_notes_and_google_title_3: 'Úvahy',
  components_review_google_text: 'Recenzie',
  media_content_section_title: 'ZVUKY',
  media_content_section_subheader_text: 'Náš podcast',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Viac epizód',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Články a štatistiky',
  text2_section_button_more: 'Načítať viac',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Zobraziť všetkých sprievodcov',
  components_footer_text: 'Prebuďte svoj vnútorný vesmír: Vaša cesta, vaše hviezdy.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registračné číslo',
  components_footer_legal: 'Právne',
  components_footer_terms: 'Zmluvné podmienky',
  components_footer_privacy: 'Zásady ochrany osobných údajov',
  button_load_more: 'Načítať viac',
  page_media_1_content_hero_text: 'Epizódy podcastov',
  page_media_content_menu_foundations: 'základy',
  page_media_content_menu_spirituality: 'Duchovnosť',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'psychológia',
  page_media_content_menu_trends: 'Trendy',
  page_media_2_content_hero_text: 'Médiá 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Náš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Články a štatistiky',
  enter_email_title: 'Ak chcete pokračovať, zadajte svoj e-mail',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Zadajte',
  components_login_success_text: 'Prihlásenie úspešné!',
  components_card_link_media_content: 'Počúvajte',
  components_card_link_text1_content: 'Zobraziť sprievodcu',
  components_card_link_text2_content: 'Zobraziť článok',
  france: 'Francúzsko',
  cyprus: 'Cyprus',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditácia',
  page_media_content_menu_all: 'Všetky',
};